import '../styles/globals.css';
import CookieBanner from '../components/CookieConsent';
import Maintenance from '../pages/Maintenance';
import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '@/utils/firebaseConfig';
import { statsUtils } from '@/utils/stats';
import SubscriptionModal from '../components/SubscriptionModal';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DefaultSeo } from 'next-seo';
import { DEFAULT_SEO } from '@/utils/seo';

function MyApp({ Component, pageProps }) {
    const isMaintenanceMode = process.env.NEXT_PUBLIC_MAINTENANCE_MODE === 'true';
    const [showAds, setShowAds] = useState(true);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                // Set up auto-sync for stats when user logs in
                statsUtils.setupAutoSync();
                
                // Try to sync local data with Firebase right after login
                try {
                    await statsUtils.syncLocalDataWithFirebase();
                    console.log("Initial data sync attempted after login");
                } catch (error) {
                    console.error("Error during initial data sync:", error);
                }
                
                const userDoc = await getDoc(doc(db, "users", user.uid));
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    const currentDate = new Date();
                    const trialEndDate = userData.trialEndDate?.toDate();
                    const isProUser = ['monthly', '3-months', 'yearly', 'lifetime'].includes(userData.plan) || userData.isPro === true;

                    if (trialEndDate && currentDate > trialEndDate) {
                        // Free trial has expired
                        await setDoc(doc(db, "users", user.uid), {
                            plan: 'free',
                            showAds: true
                        }, { merge: true });
                        setShowAds(true);

                        if (!localStorage.getItem('subscriptionModalShown')) {
                            setShowModal(true);
                        }
                    } else if (isProUser && !userData.subscriptionActive) {
                        // Pro subscription has expired
                        await setDoc(doc(db, "users", user.uid), {
                            plan: 'free',
                            showAds: true
                        }, { merge: true });
                        setShowAds(true);

                        if (!localStorage.getItem('subscriptionModalShown')) {
                            setShowModal(true); // Show the modal if the Pro subscription has expired and it hasn't been shown before
                        }
                    } else {
                        setShowAds(userData.showAds !== false);
                    }
                }
            } else {
                const isCookieBannerHidden = localStorage.getItem('cookieBannerHidden');
                setShowAds(!!isCookieBannerHidden);
            }
        });

        return () => unsubscribe();
    }, []);


    const handleCloseModal = () => {
        localStorage.setItem('subscriptionModalShown', 'true');
        setShowModal(false);
    };

    return (
        <>
            <DefaultSeo {...DEFAULT_SEO} />
            {/* Google AdSense script */}
            <script
                async
                src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9307288200117598`}
                crossOrigin="anonymous"
            />
            <Component {...pageProps} showAds={showAds}/>
            <SubscriptionModal isOpen={showModal} onClose={handleCloseModal}/>
            <CookieBanner/>
            <ToastContainer 
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}

export default MyApp;
